var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32725 8.77162C4.32725 9.26254 4.72522 9.66051 5.21614 9.66051C5.70706 9.66051 6.10503 9.26254 6.10503 8.77162V5.88898H8.98778C9.4787 5.88898 9.87667 5.49101 9.87667 5.00009C9.87667 4.50917 9.4787 4.1112 8.98778 4.1112H6.10503V1.22833C6.10503 0.737411 5.70706 0.339443 5.21614 0.339443C4.72522 0.339443 4.32725 0.737413 4.32725 1.22833V4.1112H1.44449C0.953571 4.1112 0.555603 4.50917 0.555603 5.00009C0.555603 5.49101 0.953572 5.88898 1.44449 5.88898H4.32725V8.77162Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/ic_plus.11bc5ce10641a8978a8a746602481968.svg";
export { ForwardRef as ReactComponent };